<template>
    <h1>Verifying signup...</h1>
</template>
<script>
export default {
  name: 'completesignup',
  mounted: () => {
    this.$store.dispatch('auth', {type: 'completesignup', url: window.location.href})
  }
}
</script>